import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Redirect } from 'react-router-dom';

import { authActions } from '../app/store/actions';
import { AppDispatch, RootState } from '../app/store/store';
import { User } from '../app/store/types/auth.types';
import { api } from '../helpers/api/api';
import { isUserAdmin, isUserAuthenticated } from '../services/locationService';

const getRedirectPath = (): string => {
  if (!isUserAuthenticated()) return 'auth/login';
  if (isUserAdmin()) return 'clients';

  const clientCode = api.getLoggedInUser()?.clientCode;
  return clientCode ? `${clientCode}/locations/map` : 'clientNotFound';
};

const useAuthSync = (user: User | null, dispatch: AppDispatch) => {
  useEffect(() => {
    if (!isUserAuthenticated() && user) {
      dispatch(authActions.logout());
    }
  }, [api, user, dispatch]);
};

const Root = () => {
  const user = useSelector((state: RootState) => state.Auth.user);
  const dispatch = useDispatch<AppDispatch>();

  useAuthSync(user, dispatch);

  return <Redirect to={`/${getRedirectPath()}`} />;
};

export default Root;
